import { createMuiTheme } from '@material-ui/core/styles';

export const atencyThemeV1 =  createMuiTheme({
    palette: {
        primary: {
          // light: will be calculated from palette.primary.main,
          main: '#117ac7',
          // dark: will be calculated from palette.primary.main,
          // contrastText: will be calculated to contrast with palette.primary.main
        },
        secondary: {
          light: '#fff',
          main: '#fff',
          // dark: will be calculated from palette.secondary.main,
          contrastText: '#ffcc00',
        },
        success: {
            // light: will be calculated from palette.primary.main,
            main: '#dadada',
            contrastText:'#fff'
            // dark: will be calculated from palette.primary.main,
            // contrastText: will be calculated to contrast with palette.primary.main
          },
        // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold: 3,
        // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset: 0.2,
      },typography: {
        fontFamily: [
          'IRANSans',
        
        ].join(',')}
  });
//   export const  ColorButton = withStyles(atencyThemeV1 => ({
//     root: {
//       color: atencyThemeV1.palette.getContrastText(purple[500]),
//       backgroundColor: purple[500],
//       '&:hover': {
//         backgroundColor: purple[700],
//       },
//     },
//   }))(Button);